export const SWEDISH_TRANSLATIONS = {
    tuka: {
        frontpage: 'Framsida',
        site: {
            name: 'Webbpublikation',
        },
        dropdown: {
            select_language: 'Välj språk'
        },
        search: {
            search: 'Sök',
            clear: 'Tyhjennä',
            text_search: 'Textsökning',
            text_results_header: 'Sökning med ordet',
            text_results_clear: 'Tillbaka',
            text_results_count: 'Resultat:',
            text_results_in_header: 'Otsikossa:',
            text_results_in_content: 'Sisällössä:',
            text_results_in_categories: 'Kategoriossa:',
            text_results_count_in_single_article: 'Träffar i hela kapitlet',
            text_input_placeholder: 'Sök i publikationens innehåll',
            header: 'Otsikko',
            theme_word: 'Teemasana',
            theme_word_search: 'Val av tema',
            theme_words: 'Teemat:',
            theme_word_filtered: 'Navigaatio ja sisältö suodatettu arvoilla:',
            theme_word_filter_clear: 'Tyhjennä Teemat-filtteri'
        },
        navigation: {
            table_of_contents: 'Innehåll',
            table_of_contents_filtered: 'Sisältö teemalla ',
            table_of_contents_filtered_simple: 'Innehåll med det valda temat',
            show_all_content: 'Visa hela publikationen',
            page_name: 'Sivun nimi:',
            view: 'Näkymä',
            index_info: 'Aktiivisen kohteen index:',
            open_sidebar : 'Visa innehållsförteckningen',
            close_sidebar : 'Dölj innehållsförteckningen',
            sidebar_open: 'Innehållsförteckningen öppen',
            sidebar_closed: 'Innehållsförteckningen stängd',
            accordion_open: 'Underrubrikerna öppna',
            accordion_closed: 'Underrubrikerna stängda',
            skip_to_active_sidebar_item: 'Tillbaka till innehållsförteckningen',
            skip_to_main_content: 'Hoppa över innehållsförteckningen'
        },
        messages: {
            no_active_themewords: {
                header: 'Näkyvällä sisällöllä ei havaittu valittua teemaa',
                content: 'Voit kokeilla valita uuden web-sisällön sivupalkista, vaihtaa valitun teeman tai suorittaa uuden sisältö-haun.'
            },
            no_web_content: {
                header: 'Etsittyä web-sisältöä ei löytynyt',
                content: '<div><h2>Etsittyä web-sisältöä ei löytynyt</h2><div>Voit kokeilla valita uuden web-sisällön sivupalkista tai suorittaa uuden sisältö-haun.</div></div>'
            },
            no_search_results: 'Sökningen gav inga resultat. Försök med ett annat sökord.'
        },
        warnings: {
            textSearchValueLength: 'Minsta antal tecken för textsökning:'
        },
        content: {
            table_caption: "Tabell",
            figure_caption: "Figur",
            info_box: "Informationsruta"
        },
        modal: {
            close: "Stäng"
        }
    }
};
